import { Flex, Text, useSlotRecipe } from '@chakra-ui/react';

import { usePluralisationTranslation } from '@nocowanie/common-ui';

import { getRatingDescValue } from '@app/helpers';

import { AverageRatingProps } from './average-rating.props';

export const AverageRating = ({
    ratingsAverage,
    ratingsCount,
    ratingDescription,
    ...rest
}: AverageRatingProps) => {
    const pluralizeTranslation = usePluralisationTranslation('common', 'accommodationLabels');
    const recipe = useSlotRecipe({ key: 'averageRating' });
    const styles = recipe();

    return (
        <Flex css={styles.container} data-testid="average-rating-container" {...rest}>
            <Flex css={styles.ratingNumerical} as={'span'} data-testid="average-rating-numerical">
                {ratingsAverage < 10 ? ratingsAverage.toFixed(1) : ratingsAverage}
            </Flex>
            <Flex flexDirection={'column'}>
                <Text css={styles.ratingDescription}>{getRatingDescValue(ratingDescription)}</Text>
                <Text css={styles.ratingCount} as={'span'} data-testid="average-rating-count">
                    {pluralizeTranslation(ratingsCount, 'opinion')}
                </Text>
            </Flex>
        </Flex>
    );
};
